import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import './Navbar.css'

const Navbar = () => {
    return (
        <div id="navbar-content">
        <header>
            <div>
                <Link className="navbar" to="#home" smooth>
                Home
                </Link>
            </div>
            <div>
                <Link className="navbar" to="#about" smooth>
                About
                </Link>
            </div>
            <div>
                <Link className="navbar" to="#portfolio" smooth>
                Portfolio
                </Link>
            </div>
            <div>
                <Link className="navbar" to="#contact" smooth>
                Contact Me
                </Link>
            </div>
        </header>
        </div>
    )
}

export default Navbar;